export default __webpack_public_path__ + "static/media/business-model-zoo-2.2b1ce05f.svg";